export default __webpack_public_path__ + "static/media/4ac70290024aaa28f92e498f6212ecc4.txt";